module.exports = __webpack_public_path__ + "img/she_killed_in_ecstasy_tablet.678652cb.jpg";